import { Component } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"

import GrowingTextArea from "shared/growing_text_area"

import iconTrigger from "images/icons/icon-new-connection-trigger.svg?raw"

import styles from "./dynamic_applet.module.scss"

class Trigger extends Component {
  httpExample = () => {
    const ingredients = this.props.ingredients.map(ingredient => {
      return this.buildKeyValueStructure(ingredient.slug, ingredient.example)
    })

    return `POST /ifttt/v1/webhooks/trigger_subscription/fired HTTP/1.1
Host: ${this.props.channel_api_host}
X-Request-ID: ${this.randomRequestId()}
{
  "sent_at": ${new Date().getTime()},
  "data": {
    "user_id": "${this.props.channel_user_id}",
    "connection_id": "${this.props.connection_id}",
    "trigger_id": "${this.props.full_module_name}"
  },
  "event_data": {
    "ingredients": {${ingredients}
    }
  }
}`
  }

  randomRequestId() {
    let str = ""
    str += Math.random().toString(36).substring(2, 15)
    str += Math.random().toString(36).substring(2, 15)
    str += Math.random().toString(36).substring(2, 15)
    return str
  }

  // Create the structure to display the key-value in the cURL section. If the
  // value is an object, we improve the indetation.
  buildKeyValueStructure = (key, value, space = "      ") => {
    if (typeof value === "object") {
      const objectFields = Object.keys(value).map(objectKey => {
        return this.buildKeyValueStructure(
          objectKey,
          value[objectKey],
          `${space}    ` // As a 2-level of indentation, we improve the space
        )
      })

      return `\n${space}"${key}": {${objectFields}\n${space}}`
    } else {
      const val = String(value).replace(/'|!/g, match => `\\${match}`)

      if (val.length) {
        return `\n${space}"${key}": "${val}"`
      }
    }
  }

  escapeRegExp = text => {
    return text.toString().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")
  }

  render() {
    return (
      <section className={styles["dynamic-applet-step"]} id={this.props.anchor}>
        <header
          style={{
            backgroundColor: "#" + this.props.other_channel_brand_color,
          }}
        >
          <h3>
            <span
              className={styles["svg-icon"]}
              title="Trigger"
              alt="Trigger"
              style={{
                color: "#" + this.props.other_channel_brand_color,
              }}
            >
              {parse(iconTrigger)}
            </span>
            <span className={styles.name}>{this.props.name}</span>
          </h3>
          <p className={styles.description}>{this.props.description}</p>
        </header>

        <article>
          <p className={styles["dynamic-applet-trigger-header"]}>
            Below you’ll find a sample webhook for the “{this.props.name}”
            trigger for this connection. You can simulate the “{this.props.name}
            ” event by sending us a{" "}
            <a
              href={`${this.props.docs_url}#test-trigger-event-webhook`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-inline"
            >
              test trigger request
            </a>
            . Note that triggers within the connection will be auto-subscribed.{" "}
            <a
              href={`${this.props.docs_url}#trigger-event-webhook`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-inline"
            >
              View documentation
            </a>
            .
          </p>

          <ul>
            <li
              className={styles["growing-text-area-container"]}
              title="Click to copy example"
              alt="Click to copy example"
            >
              <GrowingTextArea
                type="text"
                value={this.httpExample()}
                data-copy-field-on-click={`"${this.props.name}" example`}
                readOnly
              />
            </li>
          </ul>
        </article>
      </section>
    )
  }
}

Trigger.propTypes = {
  connection_id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  other_channel_brand_color: PropTypes.string.isRequired,
  full_module_name: PropTypes.string.isRequired,
  ingredients: PropTypes.array.isRequired,
  channel_user_id: PropTypes.string.isRequired,
  channel_api_host: PropTypes.string.isRequired,
  docs_url: PropTypes.string.isRequired,
  anchor: PropTypes.string.isRequired,
}

export default Trigger
